export default "__VITE_ASSET__Co0Arxs2__"